import type {PlatformAlert} from 'src/openapi/admin/models/PlatformAlert';

export type ClientPlatformAlert = PlatformAlert & {
    startTime: string,
    endTime: string,
};

export enum ActivePlatformAlertsSortField {
    ALERT_MESSAGE = 'ALERT_MESSAGE',
    ALERT_TYPE = 'ACCOUNT_TYPE',
    START_DATE = 'START_DATE',
    END_DATE = 'END_DATE',
    START_TIME = 'START_TIME',
    END_TIME = 'END_TIME',
}

export type ActivePlatformAlertsFilters = {
    message?: string,
    type?: string[],
};
